export const EPOCH_MIN = -16000;
export const EPOCH_MAX = 2000;

export const EPOCH_START = {
  "giza-pyramid": -2560,
  "great-sphinx": -7000,
  "stonehenge": -3000,
  "gobekli-tepe": -9600,
  "gunung-padang": -16000,
  "easter-island": 1100,
  "nazca-lines": -500,
  "machu-picchu": 1420,
  "puma-punku": -15000,
  "baalbek": -47,
  "mohenjo-daro": -2500,
  "yonaguni": -10000,
  "teotihuacan": -100,
  "nan-madol": 1100,
  "derinkuyu": -1200,
};

export const EPOCH_STOPS = [EPOCH_MIN, -10000, -5000, -2500, -1000, 0, 1000, EPOCH_MAX];

export const yearFromPos = (p) => {
  const t = Math.min(100, Math.max(0, p)) / 100;
  const seg = t * (EPOCH_STOPS.length - 1);
  const i = Math.min(EPOCH_STOPS.length - 2, Math.floor(seg));
  const f = seg - i;
  return Math.round(EPOCH_STOPS[i] + (EPOCH_STOPS[i + 1] - EPOCH_STOPS[i]) * f);
};

export const posFromYear = (year) => {
  const y = Math.max(EPOCH_MIN, Math.min(EPOCH_MAX, year));
  for (let i = 0; i < EPOCH_STOPS.length - 1; i++) {
    const a = EPOCH_STOPS[i];
    const b = EPOCH_STOPS[i + 1];
    if (y >= a && y <= b) {
      const f = (y - a) / (b - a);
      return ((i + f) / (EPOCH_STOPS.length - 1)) * 100;
    }
  }
  return 0;
};

export const formatYear = (y) =>
  y < 0 ? `${Math.abs(y).toLocaleString()} BCE` : `${y} CE`;

/* Stick-figure constellations anchored above aligned sites (local XY plane, +y up). */
export const ALIGNMENTS = {
  "giza-pyramid": {
    name: "ORION'S BELT",
    stars: [
      [-0.55, -0.1],
      [-0.05, 0.02],
      [0.45, 0.14],
      [-0.4, 0.62],
      [0.3, 0.72],
      [-0.62, -0.72],
      [0.52, -0.6],
    ],
    lines: [[0, 1], [1, 2], [0, 3], [2, 4], [0, 5], [2, 6]],
  },
  "great-sphinx": {
    name: "LEO",
    stars: [
      [0, 0],
      [0.12, 0.2],
      [0.02, 0.4],
      [0.22, 0.52],
      [0.42, 0.44],
      [0.5, 0.24],
      [0.9, 0.05],
    ],
    lines: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 1], [0, 6]],
  },
  "teotihuacan": {
    name: "THE PLEIADES",
    stars: [
      [0, 0],
      [0.1, 0.08],
      [0.18, -0.02],
      [0.05, -0.1],
      [-0.08, -0.04],
      [0.12, 0.18],
    ],
    lines: [],
  },
  "nazca-lines": {
    name: "CYGNUS",
    stars: [
      [-0.5, 0],
      [0, 0.08],
      [0.5, 0.16],
      [-0.02, 0.5],
      [0.06, -0.5],
    ],
    lines: [[0, 1], [1, 2], [1, 3], [1, 4]],
  },
};
